import Cookies from 'js-cookie';

import { AUTH_TOKEN_KEY } from 'src/constants';

export default class Auth {
  static setToken(token) {
    const options = {
      expires: 180,
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:'
    };
    console.log('🔧 Setting cookie with options:', options);
    Cookies.set(AUTH_TOKEN_KEY, token, options);
  }

  static hasToken() {
    return !!Cookies.get(AUTH_TOKEN_KEY);
  }

  static getToken() {
    return Cookies.get(AUTH_TOKEN_KEY);
  }

  static removeToken() {
    Cookies.remove(AUTH_TOKEN_KEY, {
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:'
    });
  }
}
